// extracted by mini-css-extract-plugin
export default {"menuActions":"ExpiredRecordTab_menuActions__tyDRW","statusContent":"ExpiredRecordTab_statusContent__tDeZW"};